import { gql } from '@/__generated__';

const GET_ORGANIZATION_PREFERENCES_INTERFACE = gql(`#graphql
  query GetOrganizationPreferencesInterface($input: OrganizationInput) {
    organization(input: $input) {
      id
      preferences {
        id
        interface {
          id
          defaultIndexRoute
        }
        defaultInterface: interface(defaultValues: true) {
          defaultIndexRoute
        }
      }
    }
  }
`);

export default GET_ORGANIZATION_PREFERENCES_INTERFACE;
